import React, { FC } from 'react';
import { Typography } from '@material-ui/core';

import "../css/CardAction.css";

interface HomeCardProps {
    title: string;
    clickAction: () => void
}
const CardAction: FC<HomeCardProps> = (props: HomeCardProps) => {

    const onCardClick = () => {
        props.clickAction();
    }

    return (
        <>
            <figure tabIndex={0} role="button" className=" box-shadow  card-custom" onClick={onCardClick}>
                <div className="pt-6 md:p-8 text-center md:text-left space-y-4 card-text">
                    <Typography>
                        {props.title}
                    </Typography>
                </div>
            </figure>
        </>
    );
}

export default CardAction;